<div class="login-page">
  <div class="login">
    <app-message></app-message>

    <p>Log in with your social media account</p>
    <!-- <form [formGroup]="loginForm" (ngSubmit)="login()" class="form">
      <div class="form__group">
        <label for="username">Username</label>
        <input type="text" id="username" formControlName="username">
      </div>

      <div class="form__group">
        <label for="password">Password</label>
        <input type="password" id="password" formControlName="password">
      </div>

      <div class="login-button">
        <button class="submit button is-primary">Login <i class="fal fa-sign-in-alt"></i></button>
      </div>
    </form> -->
    <div class="login-btns">
      <button class="button google" (click)="googleLogin()"> <i class="fa-brands fa-google"></i>&nbsp;&nbsp;
        Google</button>
      <button class="button fb" (click)="facebookLogin()"><i class="fa-brands fa-facebook"></i>&nbsp;&nbsp;
        Facebook</button>
    </div>
  </div>
</div>